import React, { useEffect, useState } from "react";
import classnames from "classnames";
import SVG from "react-inlinesvg";
import Dropzone from "react-dropzone";
import { motion } from "framer-motion";
import { sendAppEvent } from "../../Utils";
import { useAppStore } from "../../stores/appStore";
import { useProjectStore } from "../../stores/projectStore";

export function ImportButton({ listRef }) {
  const project = useProjectStore((state) => state.project);
  const setDocumentId = useProjectStore((state) => state.setDocumentId);

  const [loading, setLoading] = useState(false);
  const [newDocId, setNewDocId] = useState();
  const [gradientPercent, setGradientPercent] = useState(0);
  const isSW2 = useAppStore((state) => state.isSW2);

  useEffect(() => {
    if (!newDocId) return;
    setDocumentId(newDocId);
    // Post-commit, so the list includes the imported document's row.
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [newDocId]);

  return (
    <Dropzone
      accept={{
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx", ".doc"],
        "text/plain": [".txt"],
        "application/rtf": [".rtf"],
        "application/vnd.oasis.opendocument.text": [".odt"],
      }}
      disabled={loading}
      onDrop={async (acceptedFiles) => {
        setLoading(true);
        setGradientPercent(90);
        const docId = await project.importDocument(acceptedFiles[0]);
        setNewDocId(docId);
        setLoading(false);
        setGradientPercent(0);
        sendAppEvent("Document Exported", { position: "Document Action Menu" });
      }}
    >
      {({ getRootProps, getInputProps }) => (
        <motion.a
          style={{
            background: `linear-gradient(90deg, var(--primary-cta-transparent) ${gradientPercent}%, var(--menu-color)  ${gradientPercent}%)`,
          }}
          animate={{
            background: `linear-gradient(90deg, var(--primary-cta-transparent) ${gradientPercent}%, var(--menu-color)  ${gradientPercent}%)`,
            transition: {
              duration: gradientPercent === 0 ? 0 : 6,
              ease: "easeInOut",
            },
          }}
          {...getRootProps()}
          role="button"
          aria-label="Import document (.docx, .txt, .rtf, .odt)"
          className={classnames(["add", "import"], { sw2: isSW2 }, { "is-loading": loading })}
        >
          <input {...getInputProps()} />
          <SVG src="/assets/import.svg"></SVG>
          <p>Import</p>
        </motion.a>
      )}
    </Dropzone>
  );
}
